// This is to allow us to remove @sunrun/mui-theme from our dependencies without
// introducing visual changes. Anywhere that previously imported values from that
// library will import from these objects instead. Do not use these in new code.

export enum ScreenSize {
  EXTRA_SMALL = 0,
  SMALL = 480,
  MEDIUM = 768,
  LARGE = 1060,
  EXTRA_LARGE = 1440,
}

export enum FontSize {
  PX_4 = '0.25rem',
  PX_8 = '0.5rem',
  PX_12 = '0.75rem',
  PX_13 = '0.8125rem',
  PX_14 = '0.875rem',
  PX_16 = '1rem',
  PX_18 = '1.125rem',
  PX_17 = '1.0625rem',
  PX_20 = '1.25rem',
  PX_22 = '1.375rem',
  PX_23 = '1.4375rem',
  PX_24 = '1.5rem',
  PX_25 = '1.5625rem',
  PX_27 = '1.6875rem',
  PX_28 = '1.75rem',
  PX_30 = '1.875rem',
  PX_31 = '1.9375rem',
  PX_32 = '2rem',
  PX_35 = '2.188rem',
  PX_36 = '2.25rem',
  PX_39 = '2.4375rem',
  PX_40 = '2.5rem',
  PX_48 = '3rem',
  PX_49 = '3.0625rem',
  PX_56 = '3.5rem',
  PX_60 = '3.75rem',
  PX_61 = '3.8125rem',
  PX_70 = '4.375rem',
  PX_72 = '4.5rem',
  PX_75 = '4.688rem',
  PX_80 = '5rem',
}

export enum Color {
  BLACK_02 = '#FAFAFA',
  BLACK_05 = '#F2F2F3',
  BLACK_15 = '#E2E2E4',
  BLACK_45 = '#878992',
  BLACK_60 = '#61636B',
  BLACK_85 = '#3D3E43',
  BLACK_95 = '#18191B',
  CORAL = '#FD6868',
  CORAL_DARK_10 = '#D75A5A',
  CORAL_DARK_20 = '#A14444',
  CORAL_LIGHT_10 = '#FD8F8F',
  CORAL_LIGHT_20 = '#FDB0B0',
  ERROR_BACKGROUND = '#FDE5D9',
  ERROR_ICON = '#E54C00',
  ERROR_TEXT = '#6C2400',
  FERN = '#2EC25D',
  FERN_DARK_10 = '#27A54F',
  FERN_DARK_20 = '#1E7C3C',
  FERN_LIGHT_10 = '#62D185',
  FERN_LIGHT_20 = '#91DFA9',
  GOLD = '#F9AD1E',
  GOLD_DARK_10 = '#D4931A',
  GOLD_DARK_20 = '#9F6F14',
  GOLD_LIGHT_10 = '#FAC156',
  GOLD_LIGHT_20 = '#FBD388',
  INDIGO = '#383DC0',
  INDIGO_DARK_10 = '#3034A3',
  INDIGO_DARK_20 = '#24277B',
  INDIGO_LIGHT_10 = '#6A6DCF',
  INDIGO_LIGHT_20 = '#9699DD',
  INFO_BACKGROUND = '#EBF9FF',
  INFO_ICON = '#33C2FF',
  INFO_TEXT = '#144E67',
  MAGENTA = '#E428CE',
  MAGENTA_DARK_10 = '#C222AF',
  MAGENTA_DARK_20 = '#921A83',
  MAGENTA_LIGHT_10 = '#EA5EDA',
  MAGENTA_LIGHT_20 = '#F08EE5',
  PRIMARY_BLUE = '#0033FF',
  PRIMARY_BLUE_DARK = '#001670',
  PRIMARY_BLUE_LIGHT = '#2F56F4',
  PRIMARY_BLUE_LIGHTER = '#BEC9F4',
  PRIMARY_BLUE_LIGHTEST = '#F3F5FC',
  SECONDARY_BLUE = '#001F99',
  // biome-ignore lint/suspicious/noDuplicateEnumValues: SECONDARY_BLUE_DARK is a named design-system token that intentionally equals PRIMARY_BLUE_DARK
  SECONDARY_BLUE_DARK = '#001670',
  SECONDARY_BLUE_LIGHT = '#1639C5',
  SECONDARY_BLUE_LIGHTER = '#7D92E8',
  SECONDARY_BLUE_LIGHTEST = '#E4E8F6',
  SKY = '#198DE6',
  SKY_DARK_10 = '#1578C4',
  SKY_DARK_20 = '#105A93',
  SKY_LIGHT_10 = '#52A9EC',
  SKY_LIGHT_20 = '#86C2F1',
  SUCCESS_BACKGROUND = '#ECF4E6',
  SUCCESS_ICON = '#6DA145',
  SUCCESS_TEXT = '#334B20',
  WARNING_BACKGROUND = '#FFF4DE',
  WARNING_ICON = '#ED9E00',
  WARNING_TEXT = '#614100',
  WHITE = '#FFFFFF',
  BLACK = '#000000',
}

export enum FontWeight {
  LIGHT = 300,
  NORMAL = 400,
  MEDIUM = 500,
  BOLD = 600,
  EXTRA_BOLD = 700,
  MAX = 800,
}
